// @flow
import * as React from 'react';
import { FilterTagsList, FilterTag } from '../../FilterTags';

type Props = {
  what: string,
  where: string,
  isShowed: boolean,
  onWhatRemove: Function,
  onWhereRemove: Function,
};

function DisambiguationTagsList({
  what,
  where,
  isShowed,
  onWhatRemove,
  onWhereRemove,
}: Props): React.Node {
  if (!isShowed) {
    return null;
  }

  return (
    <FilterTagsList>
      {(searchParams, verticalName) => (
        <React.Fragment>
          <FilterTag
            label={what}
            verticalName={verticalName}
            onFilterTagRemove={() => onWhatRemove(searchParams)}
          />
          <FilterTag
            label={where}
            verticalName={verticalName}
            onFilterTagRemove={() => onWhereRemove(searchParams)}
          />
        </React.Fragment>
      )}
    </FilterTagsList>
  );
}

export default DisambiguationTagsList;



// WEBPACK FOOTER //
// ./app/common/Lists/DisambiguationTagsList/index.js